// extracted by mini-css-extract-plugin
export default {"pillbar":"Pill_pillbar__E4W9D","pill":"Pill_pill__VeO7w","pilllabel":"Pill_pilllabel__0o18u","pillclear":"Pill_pillclear__7DXoN"};